import React from 'react';
import styled from 'styled-components';

const LicencePageContainer = styled.div`
    margin-top: 16px;
    
    .main-table {
        margin-top: 10px;        
    }   
`;

export default LicencePageContainer;